import type { EventListQuery, EventListResponse } from "@cdt/shared";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { fetchEvents } from "@/lib/eventsApi";

// Oldest first so the journalist works through the backlog FIFO.
// pageSize 50 covers a normal editorial day comfortably; if it ever overflows
// we can add pagination or infinite scroll later.
export const REVIEW_QUEUE_QUERY: EventListQuery = {
  status: ["MANUAL_REVIEW"],
  search: undefined,
  priority: undefined,
  priorityMin: undefined,
  categoryId: undefined,
  page: 1,
  pageSize: 50,
  sortBy: "emailReceivedAt",
  sortOrder: "asc",
};

export const REVIEW_QUEUE_KEY = ["events", REVIEW_QUEUE_QUERY] as const;

export function useReviewQueue() {
  return useQuery<EventListResponse>({
    queryKey: REVIEW_QUEUE_KEY,
    queryFn: () => fetchEvents(REVIEW_QUEUE_QUERY),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
    refetchOnWindowFocus: true,
    refetchInterval: 60_000,
  });
}
